import React from "react";

import { Outlet } from "react-router-dom";
import { Container, SideBar, MobileSideBar } from "Components/navigation";
import Hidden from "Components/shared/hidden";

const MainLayout = () => {
  return (
    <>
      <Hidden smUp>
        <MobileSideBar />
      </Hidden>
      <Hidden smDown >
        <Container>
          <SideBar />
          <Outlet />
        </Container>
      </Hidden>
      <Hidden smUp>
        <Outlet />
      </Hidden>
    </>
  );
};

export default MainLayout;
